import React, { PureComponent, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';
import { Dropdown, Form, Menu } from 'semantic-ui-react';
import { getAll as getProgramList } from 'actions/programs';
import AnalysisDateMenu from 'modules/month-menu';
import StudentAggregateTable from './student-table';

const regionOptions = [
  { key: 'INDIA', value: 'INDIA', text: 'INDIA' },
  { key: 'USA', value: 'USA', text: 'USA' },
  { key: 'ANY', value: 'ANY', text: 'ANY' },
  { key: 'all', value: 'all', text: 'ALL' },
];

const stateOptions = [
  { key: 'ACT', value: 'ACT', text: 'Active' },
  { key: 'TRL', value: 'TRL', text: 'Trial' },
  { key: 'INACT', value: 'INACT', text: 'Archived' },
  { key: 'all', value: 'all', text: 'ALL' },
];

const metricOptions = [
  { key: 'green', value: 'green', text: 'GREEN' },
  { key: 'yellow', value: 'yellow', text: 'EMBER' },
  { key: 'red', value: 'red', text: 'RED' },
  { key: 'black', value: 'black', text: 'NA' },
  { key: 'all', value: 'all', text: 'ALL' },
];

class StudentAnalyticsAggregate extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      queryObj: {
        page: 1,
        page_size: 20,
        data_type: 'MTD',
        state: 'ACT',
      },
      loadCSV: false,
      searchTerm: '',
    };
  }

  static getDerivedStateFromProps({ programs, actions, teacher_id }, prevState) {
    if (programs) {
      let newState = {};
      const programList = store.getAll(programs);
      if (programList && programList.data) {
        newState['programList'] = programList.data;
      }
      return newState;
    }
    return null;
  }

  componentDidMount() {
    const { teacherID, actions } = this.props;
    const { queryObj } = this.state;
    const { getProgramList } = actions;
    getProgramList();
    if (teacherID) {
      let newQueryObj = Object.assign({}, queryObj);
      newQueryObj['teacher_id'] = teacherID;
      newQueryObj['page_size'] = 20;
      this.setState({
        queryObj: newQueryObj,
      });
    }
  }

  setPageNumberSizeSortedFiltered = (page, pageSize, sort, filter, loadCSV) => {
    const { queryObj } = this.state;
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['page'] = page;
    newQueryObj['page_size'] = pageSize;
    if (sort) {
      newQueryObj['sort_field'] = sort.id;
      newQueryObj['sort_value'] = sort.desc ? -1 : 1;
    }
    if (filter && filter.length > 0) {
      newQueryObj['filter_field'] = filter.map(fl => fl.id).join('___');
      newQueryObj['filter_value'] = filter.map(fl => fl.value).join('___');
    }
    if (queryObj !== newQueryObj) {
      this.setState({
        queryObj: newQueryObj,
        loadCSV: loadCSV,
      });
    }
  };

  handleChangeSearch = (e, { value }) => {
    this.setState({
      searchTerm: value,
    });
  };

  handleSubmitSearch = () => {
    const { queryObj, searchTerm } = this.state;
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['query'] = searchTerm;
    this.setState({
      queryObj: newQueryObj,
    });
  };

  changeProgramDropdownContent = (event, { value }) => {
    const { programList, queryObj } = this.state;
    const prgData = programList.find(prg => prg.id === value);
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['program_code'] = prgData.code;
    this.setState({
      queryObj: newQueryObj,
    });
  };

  changeRegion = (event, { value }) => {
    const { queryObj } = this.state;
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['region'] = value;
    this.setState({
      queryObj: newQueryObj,
    });
  };

  changeState = (event, { value }) => {
    const { queryObj } = this.state;
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['state'] = value;
    this.setState({
      queryObj: newQueryObj,
    });
  };

  changePerformanceMetric = (event, { value }) => {
    const { queryObj } = this.state;
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['performance_category'] = value;
    this.setState({
      queryObj: newQueryObj,
    });
  };

  changeCompletionMetric = (event, { value }) => {
    const { queryObj } = this.state;
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['completion_category'] = value;
    this.setState({
      queryObj: newQueryObj,
    });
  };

  getProgramOptions() {
    const { programList } = this.state;
    if (!programList) {
      return [];
    }
    const programOptions = programList.map(program => ({
      key: program.id,
      value: program.id,
      text: program.code,
    }));
    programOptions.push({ key: 'all', value: 'all', text: 'ALL' });
    return programOptions;
  }

  updateDates = (yrInit, yrFinal, mthInit, mthFinal, dataType) => {
    const { queryObj } = this.state;
    let newQueryObj = Object.assign({}, queryObj);
    newQueryObj['initial_month'] = yrInit + '-' + mthInit;
    newQueryObj['final_month'] = yrFinal + '-' + mthFinal;
    newQueryObj['data_type'] = dataType;
    this.setState({
      queryObj: newQueryObj,
    });
  };

  render() {
    const { teacherID, sendAggregateTeacherData } = this.props;
    const { queryObj, searchTerm, loadCSV } = this.state;
    return (
      <Fragment>
        <AnalysisDateMenu onUpdate={this.updateDates} />
        <Menu>
          <Menu.Menu position="left">
            <Menu.Item>
              <Form onSubmit={this.handleSubmitSearch}>
                <Form.Input
                  size="large"
                  icon="search"
                  placeholder="Search for Student..."
                  value={searchTerm}
                  onChange={this.handleChangeSearch}
                />
              </Form>
            </Menu.Item>

            <Menu.Item>
              <Dropdown
                style={{ minWidth: '7em' }}
                placeholder="Select Program"
                search
                selection
                value={queryObj.program_code}
                options={this.getProgramOptions()}
                onChange={this.changeProgramDropdownContent}
              />
            </Menu.Item>
            <Menu.Item>
              <Dropdown
                style={{ minWidth: '7em' }}
                placeholder="Select Region"
                search
                value={queryObj.region}
                selection
                options={regionOptions}
                onChange={this.changeRegion}
              />
            </Menu.Item>
            <Menu.Item>
              <Dropdown
                style={{ minWidth: '7em' }}
                placeholder="Select Student State"
                search
                value={queryObj.state}
                selection
                options={stateOptions}
                onChange={this.changeState}
              />
            </Menu.Item>
            <Menu.Item>
              <Dropdown
                style={{ minWidth: '7em' }}
                placeholder="Select Performance Filter"
                search
                selection
                value={queryObj.performance_category}
                options={metricOptions}
                onChange={this.changePerformanceMetric}
              />
            </Menu.Item>
            <Menu.Item>
              <Dropdown
                style={{ minWidth: '7em' }}
                placeholder="Select Completion Filter"
                search
                selection
                value={queryObj.completion_category}
                options={metricOptions}
                onChange={this.changeCompletionMetric}
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <StudentAggregateTable
          queryObj={queryObj}
          setPageNumberSizeSortedFiltered={this.setPageNumberSizeSortedFiltered}
          teacherId={teacherID}
          sendAggregateTeacherData={sendAggregateTeacherData}
          loadCSV={loadCSV}
        />
      </Fragment>
    );
  }
}

export default connect(
  ({ programs }) => ({
    programs: programs,
  }),
  dispatch => ({
    actions: bindActionCreators({ getProgramList }, dispatch),
  }),
)(StudentAnalyticsAggregate);
